export * from "./allBlocks.pure";

import { RegisterAllFlowGraphBlocks } from "./allBlocks.pure";
RegisterAllFlowGraphBlocks();
